import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import ReportType from "@app/enum/ReportType";
import getReportsHeaderDisplayName from "@app/scene/reports/utils/getReportsHeaderDisplayName";

import styles from "./Header.module.scss";

interface Props {
  className?: string;
  extra?: React.ReactNode;
  reportType: ReportType;
  titleActions?: React.ReactNode;
}

const Header: React.FC<Props> = ({ className, extra, reportType, titleActions }) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.showTitle}>
        <div className={styles.title}>{getReportsHeaderDisplayName(intl, reportType)}</div>
        {titleActions && <div className={styles.button}>{titleActions}</div>}
      </div>
      <div>
        <div>{extra}</div>
      </div>
    </div>
  );
};

export default Header;
